/* eslint-disable jsx-a11y/heading-has-content */
import React, { PropsWithChildren } from 'react';
import { merge } from '../../helpers/classes';
import { textBlue } from '../../styles/text';

type CommonProps<T> = PropsWithChildren<
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<T>, T>
> & {
  cn?: string;
};

type Props = CommonProps<HTMLHeadingElement>;

type LinkProps = CommonProps<HTMLAnchorElement>;

const sharedClasses = ['dark:text-slate-100'];
const sharedHeadingClasses = [...sharedClasses, 'font-bold', 'text-slate-800'];

const baseH1 = ['sm:text-3xl text-2xl', ...sharedHeadingClasses];
const baseH2 = ['sm:text-2xl text-xl', ...sharedHeadingClasses];
const baseH3 = ['sm:text-lg text-base', ...sharedHeadingClasses];
const baseH4 = ['sm:text-base text-sm', ...sharedHeadingClasses];

const baseP = ['font-paragraph sm:text-base text-sm', ...sharedClasses];

const baseA = [...baseP, textBlue, 'underline'];

export const H1 = (props: Props) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseH1, cn, className);

  return <h1 className={classes} {...rest} />;
};

export const H2 = (props: Props) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseH2, cn, className);

  return <h2 className={classes} {...rest} />;
};

export const H3 = (props: Props) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseH3, cn, className);

  return <h3 className={classes} {...rest} />;
};

export const H4 = (props: Props) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseH4, cn, className);

  return <h4 className={classes} {...rest} />;
};

export const H5 = (props: Props) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseH4, cn, className);

  return <h5 className={classes} {...rest} />;
};

export const P = (props: Props) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseP, cn, className);

  return <p className={classes} {...rest} />;
};

export const A = (props: LinkProps) => {
  const { cn, className, ...rest } = props;
  const classes = merge(baseA, cn, className);

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return <a className={classes} {...rest} />;
};
